import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import instanciaAxios from "../../../miscelaneo/instanciaAxios";
import SpinnerCargando from "../SpinnerCargando";
import { FaSearch } from "react-icons/fa";
import FuncionesGenerales from "../FuncionesGenerales";

const TablaAjusteInventario = ({ setAjusteSeleccionado, descripcion }) => {
  const [filtro, setFiltro] = useState("");
  const [inventarios, setInventarios] = useState([]);
  const [cargando, setCargando] = useState(true);
  const {formatoMoneda} = FuncionesGenerales()
  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setCargando(true);
        const respuesta = await instanciaAxios.get("/inventario/ajuste");
        if (respuesta.status === 200) {
          setInventarios(respuesta.data);
        } else {
          console.error("Error al obtener ajustes de inventario");
          setInventarios([]);
        }
      } catch (error) {
        console.error("Error al cargar ajustes de inventario:", error);
        setInventarios([]);
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return inventarios;
    return inventarios.filter((t) =>
      t.id_ajuste_inventario.toString().includes(filtro) ||
      (t.sucursal?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
      (t.fecha_hora?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
      ((t.nombre + ' '+(t.apellido? t.apellido : ''))?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
      (t.total?.toLowerCase() || "").includes(filtro.toLowerCase()) 

    );
  }, [inventarios, filtro]);

  const columns = [
    {
      name: "Sucursal",
      selector: (row) => row.sucursal || 'N/A',
      sortable: true,
    },
    {
      name: "Usuario",
      selector: (row) => (row.nombre + ' '+(row.apellido? row.apellido : ''))|| 'N/A',
      sortable: true,
    },
    {
      name: "Fecha y Hora",
      selector: (row) => new Date(row.fecha_hora).toLocaleString(),
      sortable: true,
    },
    {
      name: "Total",
      selector: (row) => formatoMoneda(row.total) || '---',
      right: true,
    }
  ];

  const handleRowClick = (ajuste) => {
    setAjusteSeleccionado(ajuste.id_ajuste_inventario);
  };

  if (cargando) return <SpinnerCargando />;

  if (inventarios.length === 0) {
    return (
      <div className="text-center text-gray-500 mt-5">
        No se encontraron ajustes de inventario.
      </div>
    );
  }

  return (
    <DataTable
      title={
        <>
          <h2 className="text-xl font-semibold text-center font-cascadia text-black">
            Transferencias
          </h2>
          {descripcion && (
            <p className="text-sm text-gray-500 text-center">
              {descripcion}
            </p>
          )}
        </>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      highlightOnHover
      onRowClicked={handleRowClick}
      dense
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
};

export default TablaAjusteInventario;
